import React from "react";
import { EditableResult } from "./EditableResult";
import { AnnotationPanel } from "./AnnotationPanel";

interface ChatResultPanelProps {
  copied: boolean;
  lang: string;
  result: string;
  tab: string;
  wine: string;
  modLabel?: string;
  modNumber?: string;
  onCopy: () => void;
  onExportPDF: () => void;
  onShowQR: () => void;
  onUpdateResult: (newText: string) => void;
}

export function ChatResultPanel({
  copied,
  lang,
  result,
  tab,
  wine,
  modLabel,
  modNumber,
  onCopy,
  onExportPDF,
  onShowQR,
  onUpdateResult,
}: ChatResultPanelProps) {
  return (
    <div className="overflow-hidden rounded-[28px] border border-border bg-surface shadow-[0_22px_50px_rgba(58,20,32,0.08)] animate-[fadeUp_.5s_cubic-bezier(.16,1,.3,1)]">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-foreground/[0.05] bg-accent/5 px-6 py-5">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-[14px] bg-accent font-display text-[14px] font-extrabold text-[#FFF6EE]">{modNumber}</span>
          <div>
            <div className="font-display text-[20px] font-bold tracking-[-0.04em] text-foreground">{modLabel}</div>
            <div className="text-[12px] text-tertiary">{wine} · {lang.toUpperCase()}</div>
          </div>
        </div>
        <div className="flex gap-2">
          {[
            { label: "QR", onClick: onShowQR, cls: "text-accent/70 border-accent/20" },
            { label: "PDF", onClick: onExportPDF, cls: "text-gold/70 border-gold/[0.18]" },
            {
              label: copied ? "✓ Copié" : "Copier",
              onClick: onCopy,
              cls: copied ? "text-accent border-accent-border" : "text-secondary border-border",
            },
          ].map((button) => (
            <button
              key={button.label}
              onClick={button.onClick}
              className={`min-h-[40px] rounded-[12px] border bg-transparent px-4 text-[12px] font-semibold uppercase tracking-[0.18em] ${button.cls}`}
            >
              {button.label}
            </button>
          ))}
        </div>
      </div>
      <EditableResult text={result} onChange={onUpdateResult} />
      <AnnotationPanel wine={wine} tab={tab} lang={lang} />
    </div>
  );
}